import React from "react"
import { Grid } from "@material-ui/core"

import { Portlet } from "@/components"

import { RoleFormattedForList } from "@/services/RoleService"
import RoleListIdentity from "@/pages/Admin/Role/RoleList/RoleListItem/RoleListIdentity"
import RoleListDetails from "@/pages/Admin/Role/RoleList/RoleListItem/RoleListDetails"
import RoleListActions from "@/pages/Admin/Role/RoleList/RoleListItem/RoleListActions"

type RoleListItemProps = {
	role: RoleFormattedForList
	onDelete: (roleId: number) => void
}

const RoleListItem: React.FC<RoleListItemProps> = (props) => {
	const { role, onDelete } = props

	return (
		<Portlet elevation={1}>
			<Grid container alignItems="center" spacing={2}>
				<Grid item md={3} lg={3}>
					<RoleListIdentity name={role.name} />
				</Grid>
				<Grid item md={6} lg={7}>
					<RoleListDetails role={role} />
				</Grid>
				<Grid item md={3} lg={2}>
					<RoleListActions role={role} onDelete={onDelete} />
				</Grid>
			</Grid>
		</Portlet>
	)
}

export default RoleListItem
